import { createContext, useContext } from 'react';

export interface SessionContextType {
  isAuthenticated: boolean;
  accountAddress: string | null;
  loading: boolean;
  login: (accountAddress: string) => void;
  logout: () => void;
  checkSession: () => Promise<void>;
}

export const SessionContext = createContext<SessionContextType | undefined>(undefined);

export function useSession(): SessionContextType {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error('useSession must be used within SessionProvider');
  }
  return context;
}
